// src/components/chat/conversation/listen-button/listen-button.styled.ts
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const listenPulse = keyframes`
  0%, 100% { opacity: 0.6; }
  50% { opacity: 0.85; }
`;

export const ListenControlWrap = styled.div`
    display: inline-flex;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;

    flex: 0 1 auto;
`;

export const CollapsedBtn = styled.button`
    height: 34px;

    /* ✅ Responsive collapsed button */
    width: auto;
    min-width: 120px;
    max-width: 100%;

    border-radius: 999px;
    border: 1px solid #2b2d33;
    background: #5e84ed;

    padding: 6px 16px;
    gap: 8px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;

    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #ffffff;

    transition: transform 120ms ease, filter 140ms ease, opacity 160ms ease;

    &:focus-visible {
        outline: 2px solid #ffffff;
        outline-offset: 2px;
    }

    &:hover {
        filter: brightness(1.06);
    }

    &:active {
        transform: translateY(1px);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        filter: none;
        transform: none;
    }

    &[aria-busy="true"] {
        animation: ${listenPulse} 1.4s ease-in-out infinite;
    }

    & > img {
        width: 16px;
        height: 16px;
        display: block;
    }
`;

export const SeekerWrap = styled.div`
    width: 260px;
    max-width: 100%;
    height: 34px;

    border: 1px solid var(--Brand-Accent, #5e84ed);
    border-radius: 999px;
    background: #23252a;

    display: inline-flex;
    align-items: center;

    padding-left: 19px;
    padding-right: 12px;

    min-width: 0;
    overflow: hidden;

    -webkit-user-select: none;
    user-select: none;
`;

export const PauseBtn = styled.button`
    width: 16px;
    height: 16px;

    padding: 0;
    border: 0;
    background: transparent;

    display: inline-grid;
    place-items: center;

    cursor: pointer;

    &:focus-visible {
        outline: 2px solid #ffffff;
        outline-offset: 2px;
        border-radius: 4px;
    }

    &:active {
        transform: translateY(1px);
    }
`;

export const PauseIcon = styled.img`
    width: 16px;
    height: 16px;
    display: block;
    flex: 0 0 16px;
`;

export const Track = styled.div`
    position: relative;
    flex: 1;
    height: 3px;
    background: #2b2d33;
    border-radius: 999px;
    margin-left: 19px;
    margin-right: 12px;
    overflow: hidden;

    cursor: pointer;
    outline: none;

    /* Prevent scroll/pinch from hijacking drag on mobile */
    touch-action: none;

    &:focus-visible {
        outline: 2px solid #5e84ed;
        outline-offset: 3px;
        border-radius: 999px;
    }
`;

export const Fill = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;

    /* ✅ Progress always left-to-right */
    width: 0%;
    background: #5e84ed;
    border-radius: 999px;
    transition: width 100ms linear;
`;

export const DurationText = styled.div`
    flex: 0 0 auto;

    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcb;

    white-space: nowrap;
`;
